// extracted by mini-css-extract-plugin
export default {"button":"camCaptureRecord_button__zgWDK"};